<template>
    <div style="width: 100%;">       
        <kai-form v-if="model && model.type_id == 'questionary' && model.questionary_id == 1" :model="model" @close="refresh"></kai-form>
        <ls-form v-if="model && model.type_id == 'questionary' && model.questionary_id == 2" :model="model" @close="refresh"></ls-form>
        <soc-style-form v-if="model && model.type_id == 'questionary' && model.questionary_id == 3" :model="model" @close="refresh"></soc-style-form>
    </div>
</template>

<script>
    import FormBase from "../../elements/FormBase";
    import {required, email} from 'vuelidate/lib/validators';
    import KaiForm from "./KaiForm";
    import LsForm from "./LsForm";
    import SocStyleForm from "./SocStyleForm";
    export default {
        components: {
            KaiForm,
            LsForm,
            SocStyleForm
        },
        mixins: [FormBase],
        data() {
            return {
                model: null
            };
        },
        mounted() {
        },
        created() {
        },
        methods: {
            refresh() {
                this.$api.server.post("api/public/questionary/questions", {id: this.id, lang_id: this.$api.translator.getCurrent()})
                        .then((r) => {
                            this.model = r.data;
                            
                        });
            }
        },
        computed: {
            id() {
                return this.$route.params.id;
            }
        },
        watch: {
            id: {
                handler() {
                    this.model = null;
                    this.refresh();
                },
                immediate: true
            }
        },
        validations() {

        }

    };
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/public_app/pages/questionary/Form.vue